import bloomify from '@mediashop/app/bloomreach/bloomify';
import ContentSlider from '../pattern/molecule/ContentSlider';

const ContentSliderBloomreach = (props) => <ContentSlider {...props} />;

export default bloomify(ContentSliderBloomreach);
